import { useNavigate } from "react-router";
import { useCallback } from "react";
import { PlaceOrderActionOutputSuccessful } from "@swo/storefront";
import { urlEncoded } from "../../../../../utils/browser/url-encoded";

export function useOrderPlacedHandler(purchaseConfirmationPagePath: string) {
  const navigate = useNavigate();

  return useCallback(
    (paymentResponseResult: PlaceOrderActionOutputSuccessful) => {
      const { orderId, paymentId } = paymentResponseResult;

      const location = {
        pathname: purchaseConfirmationPagePath,
        search: urlEncoded({ orderId: orderId, paymentId: paymentId }),
        state: { scrollToTop: true },
      };

      return navigate(location);
    },
    [navigate, purchaseConfirmationPagePath],
  );
}
